(function() {
    let addProductBtns = document.querySelectorAll('[data-add-product]');

    if (!addProductBtns) return;

    let mainAddProductBtn = document.getElementById('addProductBtn');
    let productsTabsNav = document.getElementById('products_tabs_nav');
    let productsTabsContent = document.getElementById('products_tabs_content');
    let removeProductButtons = document.querySelectorAll('.remove-product');

    function initClassTypesClickListener(parent) {
        [...parent.querySelectorAll('input[data-class-id]')].forEach(el => {
            el.addEventListener('change', e => {
                loadTemplate(e.target);
            });
        });
    }

    initClassTypesClickListener(document);

    [...removeProductButtons].forEach(el => {
        el.addEventListener('click', e => {
            e.stopPropagation();
            removeProduct(e.target);
        });
    });

    function loadTemplate(selectedProductClass) {
        let currentTab = selectedProductClass.closest('.tab-pane');
        let panel = currentTab.querySelector('.panel');
        let template = selectedProductClass.dataset.template;
        let latestId = parseInt(currentTab.dataset.tabId);

        $(panel).load(`/forms/${template}?id=${latestId}`, () => {});
    }

    [...addProductBtns].forEach(addProductBtn => {
        addProductBtn.addEventListener('click', () => {
            let latestId = parseInt(addProductBtn.dataset.latestId);
            let allNavTabs = productsTabsNav.querySelectorAll('.nav-link');
            let allProductTabs = productsTabsContent.querySelectorAll('.tab-pane');
            let latestNavTab = mainAddProductBtn.previousElementSibling;
            let newNavTab = latestNavTab.cloneNode(true);

            [...addProductBtns].forEach(btn => {
                btn.setAttribute('data-latest-id', `${latestId + 1}`);
            });

            newNavTab.setAttribute('id', `product_tab_${latestId + 1}`);
            newNavTab.setAttribute('href', `#product_content_${latestId + 1}`);

            let latestTabPane = productsTabsContent.lastElementChild;
            let newTabPane = latestTabPane.cloneNode(true);
            let allProductClasses = newTabPane.querySelectorAll('input[data-class-id]');

            let collapseOtherBtn = newTabPane.querySelector('.collapse-other-classes');
            let collapseOther = newTabPane.querySelector('.other-classes');

            collapseOtherBtn.setAttribute('data-target', `#other_classes_${latestId + 1}`);
            collapseOther.setAttribute('id', `other_classes_${latestId + 1}`);
            collapseOtherBtn.setAttribute('aria-expanded', 'false');
            collapseOtherBtn.classList.add('collapsed');
            collapseOther.classList.remove('show');

            newTabPane.setAttribute('id', `product_content_${latestId + 1}`);
            newTabPane.setAttribute('data-tab-id', `${latestId + 1}`);

            [...allProductClasses].forEach(el => {
                let classId = el.dataset.classId;
                el.setAttribute('id', `product_class_${latestId + 1}_${classId}`);
                el.setAttribute('name', `product[${latestId + 1}][class_id]`);
                el.nextElementSibling.htmlFor = `product_class_${latestId + 1}_${classId}`;
            });
            initClassTypesClickListener(newTabPane);

            [...allNavTabs].forEach(el => {
                el.classList.remove('active');
                el.setAttribute('aria-selected', 'false');
            });

            [...allProductTabs].forEach(el => {
                el.classList.remove('show');
                el.classList.remove('active');
            });

            newNavTab.innerHTML = `<i class="icon-exclamation text-danger mr-2 validation-warning-icon d-none"></i><span class="product-number">Product #${allNavTabs.length + 1}</span>`;
            let removeProductBtn = createProductRemoveButton(latestId + 1);
            newNavTab.appendChild(removeProductBtn);

            productsTabsNav.insertBefore(newNavTab, mainAddProductBtn);
            productsTabsContent.appendChild(newTabPane);

            let firstProductClass = newTabPane.querySelector('.nav-pills').firstElementChild.querySelector('input[data-class-id]');
            firstProductClass.checked = true;
            loadTemplate(firstProductClass);

            $(newNavTab).tab('show');

            document.getElementById('products').scrollIntoView({
                behavior: 'smooth'
            });
            
            resetFormValidation();
        });
    });

    function resetFormValidation() {
        $('.needs-validation').removeClass('was-validated');
        $('.validation-warning-icon').addClass('d-none');
    }

    function removeProduct(btn) {
        let previousNavTab = btn.parentElement.previousElementSibling;
        let currentNav = btn.parentElement;
        let productPanel = document.getElementById(`product_content_${btn.dataset.productId}`);
        let tooltip = document.querySelector('.tooltip');

        $(previousNavTab).tab('show');
        $(tooltip).remove();
        $(currentNav).remove();
        $(productPanel).remove();
        resetFormValidation();

        let allNavTabs = productsTabsNav.querySelectorAll('.nav-link');
        [...allNavTabs].forEach((el, i) => {
            el.querySelector('.product-number').innerHTML = `Product #${i + 1}`;
            el.setAttribute('id', 'product_tab_' + i);
        });
    }

    function createProductRemoveButton(id) {
        let el = document.createElement('span');

        el.innerHTML = '&times;'
        el.classList.add('remove-product');
        el.setAttribute('data-product-id', id);
        el.setAttribute('data-toggle', 'tooltip');
        el.setAttribute('data-placement', 'top');
        el.setAttribute('title', 'Remove product');
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            removeProduct(e.target);
        });

        $(el).tooltip();

        return el;
    }
})();
